// Quick-add popup support. Loaded on every page, because the popup can open anywhere product cards appear
// (collections, search, home), while jf-canvas-port.js and the jf-* block scripts only load on product/home pages.
// Horizon builds the popup from the PRODUCT PAGE's HTML, so our custom blocks arrive there as inert markup:
//   1. the gallery keeps slides 2+ as data-src until its controller hydrates them (it never runs here) -> broken images
//   2. <jf-product-head> is not an upgraded custom element here -> its price never follows the selected variant
(() => {
  const POPUP = '.quick-add-modal__content';

  const hydrateImages = (root) => root.querySelectorAll('img[data-src], img[data-srcset]').forEach((img) => {
    img.loading = 'lazy';
    if (img.dataset.srcset) { img.srcset = img.dataset.srcset; delete img.dataset.srcset; }
    if (img.dataset.src) { img.src = img.dataset.src; delete img.dataset.src; }
  });

  const money = (cents, format) => {
    const fmt = format || '${{amount}}';
    const n = cents / 100;
    const group = (s, sep) => s.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    const two = n.toFixed(2), zero = Math.round(n).toString();
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return group(zero, ',');
        case 'amount_with_comma_separator': return group(two.split('.')[0], '.') + ',' + two.split('.')[1];
        case 'amount_no_decimals_with_comma_separator': return group(zero, '.');
        case 'amount_with_apostrophe_separator': return group(two.split('.')[0], "'") + '.' + two.split('.')[1];
        default: return group(two.split('.')[0], ',') + '.' + two.split('.')[1];
      }
    });
  };

  const updatePrice = (popup, variantId) => {
    const head = popup.querySelector('jf-product-head');
    if (!head || !variantId) return;
    let variants = [];
    try { variants = JSON.parse(head.dataset.variants); } catch { return; }
    const v = variants.find((x) => String(x.id) === String(variantId));
    if (!v) return;
    const fmt = head.dataset.money;
    const set = (sel, text) => { const el = head.querySelector(sel); if (el && text !== undefined) el.textContent = text; return el; };
    set('[data-price]', money(v.price, fmt));
    const onSale = v.compare > v.price;
    const was = set('[data-compare]', money(v.compare, fmt)); if (was) was.hidden = !onSale;
    set('[data-save-amt]', money(Math.max(0, v.compare - v.price), fmt));
    const save = head.querySelector('[data-save]'); if (save) save.hidden = !onSale;
    head.dataset.current = String(variantId);
  };

  const start = () => {
    // Horizon swaps the popup's content element on every open, so watch a stable ancestor.
    const host = document.querySelector('quick-add-dialog') || document.querySelector('dialog.quick-add-modal');
    if (!host) return;
    const addDetailsLink = (popup) => {
      if (popup.querySelector('.jf-qa-more')) return;
      const title = popup.querySelector('.view-product-title a, a.view-product-title, .view-product-title');
      const href = title && (title.getAttribute('href') || title.querySelector('a')?.getAttribute('href'));
      const after = popup.querySelector('.jf-trust') || popup.querySelector('.buy-buttons-block');
      if (!href || !after) return;
      const link = document.createElement('a');
      link.className = 'jf-qa-more'; link.href = href.split('?')[0]; link.textContent = 'View full details →';
      after.insertAdjacentElement('afterend', link);
    };
    const sync = () => { const popup = host.querySelector(POPUP); if (popup) { hydrateImages(popup); addDetailsLink(popup); } };
    new MutationObserver(sync).observe(host, { childList: true, subtree: true });
    sync();

    document.addEventListener('shopify:product:select', async (event) => {
      const popup = event.target && event.target.closest && event.target.closest(POPUP);
      if (!popup || !event.promise) return;
      try {
        const result = await event.promise;
        const id = result && ((result.detail && result.detail.resource && result.detail.resource.id) || (result.variant && result.variant.id));
        if (!id) return;
        const variantId = String(id).split('/').pop();
        updatePrice(popup, variantId);
        // Horizon may morph the popup right after resolving; re-apply once it has settled.
        setTimeout(() => { const live = document.querySelector(POPUP); if (live) updatePrice(live, variantId); }, 60);
      } catch { /* aborted selection */ }
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
